import { fetchAuthSession } from 'aws-amplify/auth'

export const API_URL = process.env.REACT_APP_API_URL

export async function get(url) {
  const options = await getRequestOptions('GET')
  return fetch(url, options)
}

export async function post(url, data) {
  let options = await getRequestOptions('POST', data)

  return fetch(url, options)
}

export async function patch(url, data) {
  const options = await getRequestOptions('PATCH', data)
  return fetch(url, options)
}

export async function del(url, data) {
  const options = await getRequestOptions('DELETE', data)
  return fetch(url, options)
}

async function getRequestOptions(method, body) {
  let options = {
    method: method,
    headers: {
      'Content-Type': 'application/json'
    }
  }

  if (body) {
    options.body = JSON.stringify(body)
  }

  const { tokens } = await fetchAuthSession()
  if (tokens && tokens.accessToken) {
    // If auth session exists, add authorization header
    options.headers.Authorization = `JWT ${tokens.accessToken}`
  }

  return options;
}
